import type { Density } from '@billda/shared-ui';
import { useDensityStore } from '../../../../shared/stores/densityStore';

export const SIDEBAR_WIDTH = 240;

const densityConfig = {
  comfortable: {
    ICON_SIZE: 18,
    iconMinWidth: 32,
    navPy: 0.5,
    navMinHeight: 36,
  },
  compact: { ICON_SIZE: 16, iconMinWidth: 28, navPy: 0.375, navMinHeight: 32 },
} as const satisfies Record<Density, unknown>;

export const useSidebarDensity = () => {
  const density = useDensityStore(s => s.density);
  const cfg = densityConfig[density];
  return {
    ICON_SIZE: cfg.ICON_SIZE,
    iconSx: { minWidth: cfg.iconMinWidth },
    navItemSx: {
      borderRadius: '6px',
      mx: 1,
      mb: 0.25,
      py: cfg.navPy,
      px: 1,
      minHeight: cfg.navMinHeight,
    },
  };
};
